class infinityButton extends HTMLElement {

  constructor() {
    super();

    this.link = this.querySelector('.btn');

    if (this.link) {
      this.link.addEventListener(
        'click',
        this.handler.bind(this)
      );
    }

    if (this.classList.contains('autoscroll_yes')) {
      window.addEventListener(
        'scroll',
        this.autoscrollhandler.bind(this)
      );
    }
  }


  /*
   * Check whether product is sold out
   */
  isSoldOut(product) {
    return product.dataset.productAvailable === 'false';
  }


  /*
   * Arrange products:
   *
   * AVAILABLE
   * AVAILABLE
   * AVAILABLE
   * SOLD OUT
   * SOLD OUT
   */
  arrangeProducts(container) {

    if (!container) return;

    const products = Array.from(container.children);

    const availableProducts = [];
    const soldOutProducts = [];

    products.forEach((product) => {

      if (this.isSoldOut(product)) {
        soldOutProducts.push(product);
      } else {
        availableProducts.push(product);
      }

    });


    /*
     * Rebuild the container
     */
    const fragment = document.createDocumentFragment();

    availableProducts.forEach((product) => {
      fragment.appendChild(product);
    });

    soldOutProducts.forEach((product) => {
      fragment.appendChild(product);
    });

    container.appendChild(fragment);
  }


  /*
   * Add newly loaded products.
   *
   * Available products go BEFORE
   * existing sold-out products.
   */
  addProducts(container, newContainer) {

    if (!container || !newContainer) return;

    const newProducts =
      Array.from(newContainer.children);


    const availableProducts = [];
    const soldOutProducts = [];


    newProducts.forEach((product) => {

      if (this.isSoldOut(product)) {

        soldOutProducts.push(product);

      } else {

        availableProducts.push(product);

      }

    });


    /*
     * Find the first existing sold-out product.
     */
    const firstSoldOut =
      Array.from(container.children).find(
        (product) => this.isSoldOut(product)
      );


    /*
     * Insert available products BEFORE
     * the first sold-out product.
     */
    availableProducts.forEach((product) => {

      if (firstSoldOut) {

        container.insertBefore(
          product,
          firstSoldOut
        );

      } else {

        container.appendChild(product);

      }

    });


    /*
     * Sold-out products always go at the end.
     */
    soldOutProducts.forEach((product) => {

      container.appendChild(product);

    });

  }


  handler(event) {

    event.preventDefault();

    if (this.destroyed) return false;


    placeCollectionLoader();


    const loader =
      document.querySelector(
        '.collection_facets_loader'
      );


    if (loader) {
      loader.classList.add('loading_now');
    }


    const url =
      event.currentTarget.href;


    fetch(url)

      .then((response) => response.text())

      .then((responseText) => {

        const doc =
          new DOMParser().parseFromString(
            responseText,
            'text/html'
          );


        /*
         * Current product container
         */
        const currentContainer =
          document.querySelector(
            '.collection__container'
          );


        /*
         * New products from AJAX response
         */
        const newContainer =
          doc.querySelector(
            '.collection__container'
          );


        if (
          currentContainer &&
          newContainer
        ) {

          this.addProducts(
            currentContainer,
            newContainer
          );

        }


        /*
         * Replace Load More button
         */
        const currentButton =
          document.querySelector(
            'infinity-button'
          );


        const newButton =
          doc.querySelector(
            'infinity-button'
          );


        if (
          currentButton &&
          newButton
        ) {

          currentButton.replaceWith(
            newButton
          );

        }


        /*
         * Remove loader
         */
        if (loader) {
          loader.classList.remove(
            'loading_now'
          );
        }

      })

      .catch((error) => {

        console.error(
          'Wokiee Load More Error:',
          error
        );


        if (loader) {
          loader.classList.remove(
            'loading_now'
          );
        }

      });

  }


  autoscrollhandler() {

    if (!this.link || this.destroyed) {
      return false;
    }


    if (
      !this.link.classList.contains(
        'autoscroll'
      )
    ) {
      return false;
    }


    const contY =
      parseInt(
        this.link.parentNode.offsetTop
      );


    const wY =
      this.getWindowHeight() +
      this.getWindowTopY();


    if (contY <= wY) {

      this.link.classList.remove(
        'autoscroll'
      );


      this.link.dispatchEvent(
        new Event('click', {
          bubbles: true,
          cancelable: true
        })
      );

    }

  }


  getWindowHeight() {
    return window.innerHeight;
  }


  getWindowTopY() {
    return (
      window.pageYOffset ||
      document.documentElement.scrollTop
    );
  }


  connectedCallback() {

    /*
     * Arrange the products already
     * rendered on the first page.
     */
    const container =
      document.querySelector(
        '.collection__container'
      );


    if (container) {
      this.arrangeProducts(container);
    }

  }


  disconnectedCallback() {

    this.destroyed = true;

  }

}


customElements.define(
  'infinity-button',
  infinityButton
);